import "./style.scss";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import Lock from "./img/lock.svg?react";
import Check from "./img/check.svg?react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "react-range-slider-input/dist/style.css";
import { useRef } from "react";
import ArrowButton from "@components/ArrowButton";
import DOMPurify from "dompurify";

const statuses = [
  {
    id: 1,
    name: "Einsteiger",
    features: [
      { reward: "0P" },
      { active: true },
      { active: true },
      { active: true },
      { active: true },
      { active: true },
      { active: false },
      { active: false },
      { active: false },
      { active: false },
    ],
    range: "0-199",
  },
  {
    id: 2,
    name: "Profi",
    features: [
      { reward: "100P" },
      { active: true },
      { active: true },
      { active: true },
      { active: true },
      { active: true },
      { active: true },
      { active: true },
      { active: true },
      { active: false },
    ],
    range: "200-999",
  },
  {
    id: 3,
    name: "Experte",
    features: [
      { reward: "200P" },
      { active: true },
      { active: true },
      { active: true },
      { active: true },
      { active: true },
      { active: true },
      { active: true },
      { active: true },
      { active: true },
    ],
    range: "1000-2000",
  },
];

const featureNames = [
  "Aufstiegs-Prämie",
  "Wunschgutschein Gutscheine",
  "glo™-Zubehör Gutscheine",
  "Gutscheine für Vuse-Zubehör",
  "Merchandise",
  "Vuse-Geräte & E-Liquids Gutscheine",
  "glo™-Geräte Gutscheine",
  "HoReCa Gutscheine",
  "Überraschungs-Geschenke",
  "Tickets für Festivals",
];

export default function StatusSwiper({ activeStatus, section }) {
  const swiperRef = useRef();

  return (
    <div className="status-grid">
      <div className="status-swiper-wrapper">
        <Swiper
          slidesPerView="auto"
          className="status-swiper"
          navigation={{
            nextEl: ".status-swiper-button-next",
            prevEl: ".status-swiper-button-prev",
          }}
          ref={swiperRef}
          modules={[Navigation]}
          breakpoints={{
            0: {
              slidesPerView: 1.2,
              spaceBetween: 16,
            },
            520: {
              slidesPerView: 1.5,
              spaceBetween: 16,
            },
            1480: {
              slidesPerView: 1.6,
              spaceBetween: 24,
            },
            1590: {
              slidesPerView: 2.5,
              spaceBetween: 12,
            },
            1780: {
              slidesPerView: 3,
              spaceBetween: 32,
            },
          }}
        >
          {statuses.map((status) => (
            <SwiperSlide key={status.id}>
              <div className="status-list">
                <div className="row row-header">
                  <div
                    className={`col ${activeStatus >= status.id ? "" : "lock"}`}
                  >
                    {activeStatus >= status.id ? (
                      <Check
                        className={`status-icon ${
                          activeStatus >= status.id ? "" : "lock"
                        }`}
                      />
                    ) : (
                      <Lock
                        className={`status-icon ${
                          activeStatus >= status.id ? "" : "lock"
                        }`}
                      />
                    )}

                    {status.name}
                  </div>
                  <div className="col">
                    {status.range}
                    <span>SP</span>
                  </div>
                </div>
                {status.features.map((feature, index) => (
                  <div className="row row-content" key={index}>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(featureNames[index]),
                      }}
                      className="col"
                    />
                    <div className="col">
                      {feature.desc && (
                        <span
                          dangerouslySetInnerHTML={{
                            __html: DOMPurify.sanitize(feature.desc),
                          }}
                          className={`extra-content ${
                            activeStatus >= status.id ? "" : "lock"
                          }`}
                        />
                      )}
                      {feature.reward ? (
                        <span
                          className={`status-reward ${
                            activeStatus >= status.id ? "" : "lock"
                          }`}
                        >
                          {feature.reward}
                        </span>
                      ) : feature.active ? (
                        <Check
                          alt="Check"
                          className={`status-icon ${
                            activeStatus >= status.id ? "" : "lock"
                          }`}
                        />
                      ) : (
                        <Lock
                          alt="Check"
                          className={`status-icon ${
                            activeStatus >= status.id ? "" : "lock"
                          }`}
                        />
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      <div className={`cta-group ${section}`}>
        <div className="status-swiper-button-prev">
          <ArrowButton reverse />
        </div>
        <div className="status-swiper-button-next">
          <ArrowButton />
        </div>
      </div>
    </div>
  );
}
